import { create } from "zustand";

export interface FilterItem {
  key: string;
  value: string | number | boolean;
}

export type SortOrder = "ASC" | "DESC" | "";

interface ScreenState {
  pageSize: number;
  currentPage: number;

  searchValue: string;

  filterValue: FilterItem[] | null;

  order: SortOrder;
  orderBy: string;

  mapTypeFilter: string[];
  mapBikeStateFilter: string[];
  mapStationTypeFilter: string[];
  mapStationStateFilter: string[];

  setPageSize: (size: number) => void;
  setCurrentPage: (page: number) => void;
  setSearchValue: (value: string) => void;
  setFilterValue: (filters: FilterItem[] | null) => void;
  setOrder: (order: SortOrder) => void;
  setOrderBy: (field: string) => void;
  setSorting: (orderBy: string, order: SortOrder) => void;
  setMapTypeFilter: (types: string[]) => void;
  setMapBikeStateFilter: (states: string[]) => void;
  setMapStationTypeFilter: (types: string[]) => void;
  setMapStationStateFilter: (states: string[]) => void;
  resetFilters: () => void;
  resetAll: () => void;
}

const DEFAULT_PAGE_SIZE = 25;

export const useScreenStore = create<ScreenState>()((set) => ({
  pageSize: DEFAULT_PAGE_SIZE,
  currentPage: 1,
  searchValue: "",
  filterValue: null,
  order: "" as SortOrder,
  orderBy: "",
  mapTypeFilter: [],
  mapBikeStateFilter: [],
  mapStationTypeFilter: [],
  mapStationStateFilter: [],

  setPageSize: (size) => set({ pageSize: size, currentPage: 1 }),

  setCurrentPage: (page) => set({ currentPage: page }),

  setSearchValue: (value) => set({ searchValue: value, currentPage: 1 }),

  setFilterValue: (filters) => set({ filterValue: filters, currentPage: 1 }),

  setOrder: (order) => set({ order }),

  setOrderBy: (field) => set({ orderBy: field }),

  setSorting: (orderBy, order) => set({ orderBy, order }),

  setMapTypeFilter: (types) => set({ mapTypeFilter: types }),

  setMapBikeStateFilter: (states) => set({ mapBikeStateFilter: states }),

  setMapStationTypeFilter: (types) => set({ mapStationTypeFilter: types }),

  setMapStationStateFilter: (states) => set({ mapStationStateFilter: states }),

  resetFilters: () =>
    set({
      filterValue: null,
      searchValue: "",
      currentPage: 1,
    }),

  resetAll: () =>
    set({
      pageSize: DEFAULT_PAGE_SIZE,
      currentPage: 1,
      searchValue: "",
      filterValue: null,
      order: "" as SortOrder,
      orderBy: "",
      mapTypeFilter: [],
      mapBikeStateFilter: [],
      mapStationTypeFilter: [],
      mapStationStateFilter: [],
    }),
}));

export const usePageSize = () => useScreenStore((state) => state.pageSize);
export const useCurrentPage = () =>
  useScreenStore((state) => state.currentPage);
export const useSearchValue = () =>
  useScreenStore((state) => state.searchValue);
export const useFilterValue = () =>
  useScreenStore((state) => state.filterValue);
export const useSorting = () =>
  useScreenStore((state) => ({
    order: state.order,
    orderBy: state.orderBy,
  }));
